import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../components/modal/Modal';
import Button from '../../../components/button/Button';
import AutoCompleteInstructor from '../../../components/autoCompleteInstructor/AutoCompleteInstructor';
import TextAreaField from '../../../components/textAreaField/TextAreaField';
import LoadingOverlay from '../../../components/loadingOverlay/LoadingOverlay';
import Icon from '../../../components/icon/Icon';
import axiosClient from '../../../api/axiosClient';
import { useToasts } from '../../../contexts/ToastContext';
import styles from '../../../components/evaluationForm/EvaluationForm.module.scss';

const TransferEvaluationModal = ({ evaluationId, onClose, onSuccess }) => {
  const { showToast } = useToasts();
  const [instructorList, setInstructorList] = useState([]);
  const [instructor, setInstructor] = useState(null);
  const [instructorError, setInstructorError] = useState('');
  const [note, setNote] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    axiosClient.get('users/instructors').then((response) => {
      if (response.data?.instructors) {
        const instructors = [];
        response.data.instructors.forEach((item) => {
          item.clinicalSites.forEach((site) => {
            instructors.push({
              instructorId: item.id,
              firstName: item.firstName,
              lastName: item.lastName,
              profilePicture: item.profilePicture,
              clinicalSiteId: site.id,
              clinicalSite: site.name,
              specialities: item.specialities ? item.specialities.map(s => s.name).join(',') : '',
              email: item.email ?? '',
            });
          });
        });
        setInstructorList(instructors);
      }
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!instructor) {
      setInstructorError('Instructor is required');
      return;
    }
    setIsSubmitting(true);
    axiosClient.patch(`evaluation-requests/transfer/${evaluationId}`, {
      toInstructorId: instructor.instructorId,
      clinicalSiteId: instructor.clinicalSiteId,
      note,
    })
      .then(() => {
        showToast('Evaluation transferred successfully', 'success');
        onSuccess?.();
        onClose();
      })
      .catch((error) => {
        showToast(error.message, 'error');
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <Modal scrollable={false}>
      {isSubmitting && <LoadingOverlay />}
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.header}>
          <span><Icon name="clipboard" /></span>
          <h3>Transfer Evaluation Request</h3>
        </div>
        <div className={styles.inputContainer}>
          <span className={styles.icon}><Icon name="users" /></span>
          <div className={styles.input}>
            <AutoCompleteInstructor
              label="Choose Instructor"
              list={instructorList}
              onChange={(selected) => {
                setInstructor(selected);
                if (selected) setInstructorError('');
              }}
              error={instructorError}
            />
          </div>
        </div>
        <div className={styles.inputContainer}>
          <span className={styles.icon}><Icon name="file-text" /></span>
          <div className={styles.input}>
            <TextAreaField
              label="Notes"
              value={note}
              onChange={(val) => setNote(val)}
            />
          </div>
        </div>
        <div className={styles.actions}>
          <Button label="Cancel" variant="secondary" size="medium" onClick={onClose} />
          <Button label="Transfer" variant="primary" size="medium" type="submit" />
        </div>
      </form>
    </Modal>
  );
};

TransferEvaluationModal.propTypes = {
  evaluationId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
};

export default TransferEvaluationModal;
